import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import qs from "qs";
import { IPaginated } from 'src/types/paginated';
import httpRequest from 'src/helpers/httpRequest';
import PaginationComponet from '../GlobalComponents/PaginationComponet';
import { printServiceDuration, truncateString } from 'src/helpers/helperFunctions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import IsFavoriteComponent from 'src/Components/Customer/ProductsAndServicesComponents/IsFavoriteComponent';
import { CircularProgress } from '@mui/material';
import { Link } from 'react-router-dom';
import wishlistIcon from 'src/assets/images/no-wishlist-icon.png'
import { CURRENCY } from 'src/lib/constans';

interface IObj {
    _id: string;
    serviceName: string;
    image: string;
    ratingCount: number;
    averageRating: number;
    price: number;
    prescriptionRequired: boolean;
    isLiked: boolean;
    shortDescription: string;
    serviceDuration: string;
    healthCareProvider: string;
};
interface IResponse {
    documents: IObj[];
    paginated: IPaginated;
};

const FavHomecare: React.FC = () => {
    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [data, setData] = useState<IObj[]>([]);
    const [paginated, setPaginated] = useState<IPaginated>({
        currentPage: 1,
        totalPages: 1,
    });
    const [queryParams, setQueryParams] = useState<{ page: number; limit: number; bool: boolean; }>({
        page: 1,
        limit: 10,
        bool: false,
    });
    const handleRemove = (obj: { productId: string; }) => {
        if (data?.length > 1) {
            setData(prev => prev?.filter(v => v._id !== obj?.productId));
        } else {
            setQueryParams(prev => ({
                ...prev,
                bool: !prev.bool,
                page: prev?.page > 1 ? prev?.page - 1 : prev?.page
            }));
        }
    };
    const fetch = async () => {
        setIsLoader(true);
        const { bool, ...actulaParams } = queryParams;
        const { res, err } = await httpRequest<IResponse>({ path: `/home-care-services/getfavproducts?${qs.stringify(actulaParams)}` });
        if (res) {
            setData(res?.documents || []);
            setPaginated(res?.paginated);
        } else {
            toast(err, { type: "error" });
        }
        setIsLoader(false);
    };
    useEffect(() => {
        fetch();
    }, [queryParams]);
    return (
        <div className="my-list-dashbaord-main">
            {isLoader ?
                <div className='flex justify-center mt-6'>
                    <CircularProgress style={{ width: 24, height: 24, color: "#00443f" }} />
                </div>
                : data?.length ?
                    data?.map(item => (
                        <div key={item?._id} className="my-list-dashbaord">
                            <div className='my-list-dashbaord-left'>
                                <img src={`${item?.image}`} alt="" />
                            </div>
                            <div className='customer-pharmacy-card-content-text'>
                                <div className='flex items-start justify-between'>
                                    <div>
                                        <span className='font-Poppins-Medium font-size-18px theme-color-green'>{truncateString(item?.serviceName || "", 70)}</span>
                                        <p className='font-size-16px font-Poppins-SemiBold w-[60%] text-[#4F6367]'>{truncateString(item?.shortDescription, 100)}</p>
                                    </div>
                                    <button>
                                        <IsFavoriteComponent
                                            category="homecare"
                                            onSuccess={handleRemove}
                                            productId={item?._id}
                                            isFav={item?.isLiked || false}
                                        />
                                    </button>
                                </div>
                                <div className='flex justify-between'>
                                    <div className="text-yellow-400 flex flex-row reviewstars">
                                        {[1, 2, 3, 4, 5].map((v) => (
                                            <FontAwesomeIcon
                                                key={v}
                                                className={(item?.averageRating || 0) >= v ? "text-[#facc15] font-size-20px" : "text-[#b7b6b1] font-size-20px"}
                                                icon={faStar}
                                            />
                                        ))}
                                    </div>
                                    <strong className='font-size-20px font-Poppins-Bold theme-color-green'>{CURRENCY} {item?.price}</strong>
                                </div>
                                <div className='flex justify-between'>
                                    <div className='my-list-service-duration'>
                                        <div className='my-list-service-duration-left'>
                                            <span className='font-Poppins-SemiBold font-size-14px theme-color-green'>Service Duration</span>
                                            <p className='font-Poppins-Medium font-size-14px text-[#616161]'>{printServiceDuration(item?.serviceDuration || "")}</p>
                                        </div>
                                        <div className='my-list-service-duration-right'>
                                            <span className='font-Poppins-SemiBold font-size-14px theme-color-green'>Healthcare provider</span>
                                            <p className='font-Poppins-Medium font-size-14px text-[#616161]'>{item?.healthCareProvider}</p>
                                        </div>
                                    </div>
                                    <Link
                                        to={`/customer/service/${item?._id}/view`}
                                        className="theme-bg-green add-to-cart-text-btn text-[#FFFFFF] font-size-16px font-Poppins-SemiBold"
                                    >
                                        Book Appointment
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))
                    :
                    <div className='parchi-icon-order'>
                        <img src={wishlistIcon} alt="" />
                        <span className="text-center font-Poppins-Medium font-size-22px">No At-home Services in the list</span>
                    </div>
            }
            {paginated?.totalPages > 1 &&
                <PaginationComponet
                    total={paginated.totalPages}
                    currentPage={paginated.currentPage}
                    setCurrentPage={(_page) => setQueryParams(prev => ({ ...prev, page: _page }))}
                />
            }
        </div>
    );
};

export default FavHomecare;